import { useEffect } from "react";
import { useAuth } from "@/Common/Auth/AuthContext";

function canUseWebPush() {
  return (
    typeof window !== "undefined" &&
    typeof window.Notification === "function" &&
    "serviceWorker" in navigator
  );
}

export default function FirebaseMessaging() {
  const { loggedIn } = useAuth();

  useEffect(() => {
    if (!canUseWebPush()) return undefined;

    let cancelled = false;

    import("@/lib/firebase/pushNotifications")
      .then((mod) => {
        if (cancelled) return;
        mod.enablePushOnFirstUserGesture();
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (!canUseWebPush()) return undefined;

    import("@/lib/firebase/pushNotifications")
      .then((mod) => mod.registerFirebasePush())
      .catch(() => {});

    return undefined;
  }, [loggedIn]);

  return null;
}
